import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

interface Book {
  id: string;
  title: string;
  author: string;
  cover: string;
  coverAlt: string;
  rating: number;
  genre: string;
  reviewDate: string;
  reviewExcerpt: string;
}

const allBooks: Book[] = [
{
  id: 'book_1',
  title: 'The Midnight Library',
  author: 'Matt Haig',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1b87a6d05-1766775987298.png",
  coverAlt: 'The Midnight Library book cover showing dark blue background with golden library illustration',
  rating: 4.5,
  genre: 'Fiction',
  reviewDate: '2026-01-28',
  reviewExcerpt: 'A profound exploration of life choices and infinite possibilities that will make you question every decision.'
},
{
  id: 'book_2',
  title: 'Project Hail Mary',
  author: 'Andy Weir',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1b8589ffb-1765370251985.png",
  coverAlt: 'Project Hail Mary book cover with space and rocket imagery on dark background',
  rating: 5.0,
  genre: 'Science Fiction',
  reviewDate: '2026-01-25',
  reviewExcerpt: 'Weir delivers another masterpiece of hard science fiction with heart, humor, and incredible problem-solving.'
},
{
  id: 'book_3',
  title: 'The Seven Husbands of Evelyn Hugo',
  author: 'Taylor Jenkins Reid',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1f2d2c4a5-1765370248901.png",
  coverAlt: 'The Seven Husbands of Evelyn Hugo book cover with elegant vintage Hollywood aesthetic',
  rating: 4.8,
  genre: 'Historical Fiction',
  reviewDate: '2026-01-22',
  reviewExcerpt: 'A captivating tale of love, ambition, and Hollywood glamour that spans decades with unforgettable characters.'
},
{
  id: 'book_4',
  title: 'Atomic Habits',
  author: 'James Clear',
  cover: "https://images.unsplash.com/photo-1716171848317-1ca95b7f99ef",
  coverAlt: 'Atomic Habits book cover with minimalist design and bold typography',
  rating: 4.7,
  genre: 'Self-Help',
  reviewDate: '2026-01-20',
  reviewExcerpt: 'A practical, science-backed guide to building good habits and breaking bad ones with actionable strategies.'
},
{
  id: 'book_5',
  title: 'The Silent Patient',
  author: 'Alex Michaelides',
  cover: "https://images.unsplash.com/photo-1709671704815-29c6dccb0adc",
  coverAlt: 'The Silent Patient book cover with mysterious woman silhouette on dark background',
  rating: 4.3,
  genre: 'Thriller',
  reviewDate: '2026-01-18',
  reviewExcerpt: 'A psychological thriller that keeps you guessing until the very end with a shocking twist you won\'t see coming.'
},
{
  id: 'book_6',
  title: 'Educated',
  author: 'Tara Westover',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1a67dd3db-1766575716473.png",
  coverAlt: 'Educated memoir book cover with mountain landscape and graduation cap imagery',
  rating: 4.9,
  genre: 'Biography',
  reviewDate: '2026-01-15',
  reviewExcerpt: 'A powerful memoir about education, family, and self-discovery that showcases the transformative power of learning.'
},
{
  id: 'book_7',
  title: 'Where the Crawdads Sing',
  author: 'Delia Owens',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1704451fb-1764675693824.png",
  coverAlt: 'Where the Crawdads Sing book cover with marsh landscape and watercolor aesthetic',
  rating: 4.4,
  genre: 'Fiction',
  reviewDate: '2026-01-12',
  reviewExcerpt: 'A beautifully written coming-of-age story set in the marshlands with mystery and romance intertwined.'
},
{
  id: 'book_8',
  title: 'The Name of the Wind',
  author: 'Patrick Rothfuss',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1ae824976-1769488098492.png",
  coverAlt: 'The Name of the Wind fantasy book cover with magical elements and medieval aesthetic',
  rating: 4.6,
  genre: 'Fantasy',
  reviewDate: '2026-01-10',
  reviewExcerpt: 'An epic fantasy with masterful prose, complex magic system, and a protagonist you can\'t help but root for.'
},
{
  id: 'book_9',
  title: 'Sapiens',
  author: 'Yuval Noah Harari',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1cbf32cda-1769722949805.png",
  coverAlt: 'Sapiens book cover with minimalist human evolution imagery',
  rating: 4.5,
  genre: 'Non-Fiction',
  reviewDate: '2026-01-08',
  reviewExcerpt: 'A thought-provoking exploration of human history that challenges everything you thought you knew about our species.'
},
{
  id: 'book_10',
  title: 'The Song of Achilles',
  author: 'Madeline Miller',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_112c4d0ce-1766751771237.png",
  coverAlt: 'The Song of Achilles book cover with ancient Greek aesthetic and golden accents',
  rating: 4.8,
  genre: 'Historical Fiction',
  reviewDate: '2026-01-05',
  reviewExcerpt: 'A stunning retelling of the Iliad that brings ancient Greek mythology to life with emotional depth.'
},
{
  id: 'book_11',
  title: 'The Invisible Life of Addie LaRue',
  author: 'V.E. Schwab',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1ac74f1fd-1765370257141.png",
  coverAlt: 'The Invisible Life of Addie LaRue book cover with ethereal woman and magical elements',
  rating: 4.7,
  genre: 'Fantasy',
  reviewDate: '2026-01-03',
  reviewExcerpt: 'A hauntingly beautiful story about a woman cursed to be forgotten by everyone she meets across 300 years.'
},
{
  id: 'book_12',
  title: 'The Martian',
  author: 'Andy Weir',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1870f725e-1767929789582.png",
  coverAlt: 'The Martian book cover with Mars landscape and astronaut imagery',
  rating: 4.9,
  genre: 'Science Fiction',
  reviewDate: '2026-01-01',
  reviewExcerpt: 'A gripping survival story on Mars filled with science, humor, and the indomitable human spirit.'
}];


interface BookGridProps {
  selectedGenre: string;
}

export default function BookGrid({ selectedGenre }: BookGridProps) {
  const filteredBooks = selectedGenre === 'all' ?
  allBooks :
  allBooks.filter((book) => book.genre.toLowerCase().replace(/\s+/g, '') === selectedGenre);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {filteredBooks.map((book) =>
      <Link
        key={book.id}
        href="/book-reviews"
        className="group cursor-pointer">

          <div className="glass-card rounded-xl overflow-hidden hover:bg-card/80 transition-all duration-300 h-full">
            {/* Book Cover */}
            <div className="relative h-72 overflow-hidden bg-muted">
              <AppImage
              src={book.cover}
              alt={book.coverAlt}
              className="w-full h-full object-cover image-hover-zoom grayscale group-hover:grayscale-0 transition-all duration-700" />

              
              {/* Rating Badge */}
              <div className="absolute top-4 right-4 flex items-center gap-1 px-3 py-1.5 rounded-full bg-background/90 backdrop-blur-sm">
                <Icon name="StarIcon" size={14} className="text-accent" />
                <span className="text-sm font-semibold text-foreground">{book.rating}</span>
              </div>

              {/* Genre Badge */}
              <div className="absolute bottom-4 left-4 px-3 py-1.5 rounded-full bg-primary/90 backdrop-blur-sm">
                <span className="text-xs font-semibold uppercase tracking-wider text-primary-foreground">
                  {book.genre}
                </span>
              </div>
            </div>

            {/* Book Info */}
            <div className="p-5">
              <h3 className="text-lg font-serif font-semibold text-foreground mb-2 group-hover:text-primary transition-colors line-clamp-2">
                {book.title}
              </h3>

              <p className="text-sm text-muted-foreground mb-3">
                by {book.author}
              </p>

              <p className="text-xs text-foreground/70 line-clamp-2 leading-relaxed">
                {book.reviewExcerpt}
              </p>

              <div className="mt-4 pt-4 border-t border-border flex items-center justify-between">
                <span className="text-xs text-muted-foreground">
                  {new Date(book.reviewDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                </span>
                <div className="flex items-center gap-1 text-primary opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="text-xs font-medium">Read Review</span>
                  <Icon name="ArrowRightIcon" size={14} />
                </div>
              </div>
            </div>
          </div>
        </Link>
      )}
    </div>);

}